import * as logos from '../../../static/img/techpartners'

const logoMap: Record<string, string> = logos

const getPartnerLogo = (iconName: string): string | undefined => {
  return logoMap[iconName]
}

export default getPartnerLogo
